export default "__VITE_ASSET__C8gB66w9__"